import { render, staticRenderFns } from "./ComplaintReceivedSummary.vue?vue&type=template&id=4447c7ac&"
import script from "./ComplaintReceivedSummary.vue?vue&type=script&lang=js&"
export * from "./ComplaintReceivedSummary.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintReceivedSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports